export const sectionContribua = {
  textAlign: 'center',
  padding: '4rem 1rem',
};

export const tituloContribua = {
  fontSize: '32px',
  fontWeight: 700,
  color: '#E72360',
  marginBottom: '1rem',
};

export const descricaoContribua = {
  fontSize: '16px',
  color: '#555',
  maxWidth: '600px',
  margin: '0 auto 3rem',
  lineHeight: 1.5,
};

export const containerCards = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '2rem',
  marginBottom: '3rem',
};

export const card = {
  backgroundColor: '#FFF',
  borderRadius: '12px',
  boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
  padding: '1.5rem',
  width: '280px',
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const subtituloCartao = {
  fontSize: '18px',
  fontWeight: 700,
  color: '#5A2D82',
  margin: '0.5rem 0'
};

export const divider = {
  width: '100%',
  border: 'none',
  borderTop: '1px solid #EEE',
  margin: '0.75rem 0'
};

export const gridConteudo = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  rowGap: '0.75rem',
  columnGap: '1rem',
  width: '100%'
};

export const labelField = {
  fontSize: '14px',
  color: '#555',
  alignSelf: 'center',
  fontWeight: 700,
};

export const valueField = {
  fontSize: '16px',
  fontWeight: 500,
  color: '#5A2D82',
  alignSelf: 'center'
};

export const logo = {
  height: '40px',
  marginBottom: '1rem',
};

export const label = {
  fontSize: '14px',
  color: '#777',
  marginTop: '0.5rem',
};

export const value = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
};

export const qrImage = {
  width: '160px',
  height: '160px',
  objectFit: 'cover',
  marginBottom: '1rem',
};

export const caption = {
  fontSize: '15px',
  fontWeight: 700,
  color: '#5A2D82',
  wordBreak: 'break-all',
  textAlign: 'center',
};

export const avisoBox = {
  border: '2px solid #9E3156',
  borderRadius: '8px',
  padding: '1rem 1.5rem',
  maxWidth: '800px',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1rem',
};

export const avisoIcon = {
  fontSize: '24px',
  color: '#E72360',
  marginTop: '2px',
};

export const avisoText = {
  fontSize: '14px',
  color: '#555',
  lineHeight: 2,
  textAlign: 'left',
};

export const urlLink = {
display: 'inline-block',
backgroundColor: '#E72360',
color: '#FFF',
fontSize: '13px',
fontWeight: 500,
padding: '0.4rem 0.8rem',
borderRadius: '16px',
textDecoration: 'none',
marginTop: '0.5rem',
wordBreak: 'break-all',
transition: 'background-color 0.3s',
};
